import React, { useState, useEffect } from 'react';
import { loadOrg } from '../../api/api';
import { loadMentorByOrg, setDept } from '../../api/settingApi';
import { useNavigate } from 'react-router-dom';

const NewDept = () => {
    console.log('NewDept component loaded');

    const navigate = useNavigate();

    const user = JSON.parse(sessionStorage.getItem('lgusr'));
    const isAdmin = user?.role === 'ADMINISTRATOR';
    const org_id = user?.orgId;
    console.log('User Org ID:', org_id);

    const [organizations, setOrganizations] = useState([]);
    const [mentors, setMentors] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const [formData, setFormData] = useState({
        name: '',
        description: '',
        organizationId: isAdmin ? '' : org_id,
        mentorId: '',
    });

    useEffect(() => {
        if (isAdmin) {
            const fetchOrganizations = async () => {
                setLoading(true);
                try {
                    const response = await loadOrg();
                    setOrganizations(response);
                } catch (error) {
                    console.error('Error fetching organizations:', error);
                    setOrganizations([]);
                } finally {
                    setLoading(false);
                }
            };
            fetchOrganizations();
        }
    }, [isAdmin]);

    useEffect(() => {
        if (formData.organizationId > 0) {
            const fetchMentors = async () => {
                setLoading(true);
                try {
                    const response = await loadMentorByOrg(formData.organizationId);
                    console.log('Fetched mentors:', response);
                    setMentors(response);
                } catch (error) {
                    console.error('Error fetching mentors:', error);
                    setMentors([]);
                } finally {
                    setLoading(false);
                }
            };
            fetchMentors();
        }
    }, [formData.organizationId]);

    const validate = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = 'Department name is required';
        if (!formData.organizationId) newErrors.organizationId = 'Please select an organization';
        if (!formData.mentorId) newErrors.mentorId = 'Please select a mentor';
        return newErrors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]:
                ['organizationId', 'mentorId'].includes(name) && value !== ''
                    ? Number(value)
                    : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setErrors({});
        try {
            const response = await setDept(formData);
            console.log(response);
            navigate('/settings');
        } catch (error) {
            console.error('Error submitting form:', error);
        }
    };

    return (
        <div className="max-w-2xl mx-auto p-6 bg-white rounded-lg shadow-md">
            <h2 className="text-2xl font-bold mb-4">Add Department</h2>

            {loading && <p className="text-gray-500">Loading...</p>}

            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700">
                        Department Name
                    </label>
                    <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className="block w-full px-4 py-2 mt-1 border rounded-md focus:ring-teal-500 focus:border-teal-500"
                    />
                    {errors.name && (
                        <p className="text-red-500 text-sm mt-1">{errors.name}</p>
                    )}
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700">
                        Description
                    </label>
                    <input
                        type="text"
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        className="block w-full px-4 py-2 mt-1 border rounded-md focus:ring-teal-500 focus:border-teal-500"
                    />
                </div>

                {isAdmin && (
                    <div>
                        <label className="block text-sm font-medium text-gray-700">
                            Organization
                        </label>
                        <select
                            name="organizationId"
                            value={formData.organizationId}
                            onChange={handleChange}
                            className="block w-full px-4 py-2 mt-1 border rounded-md focus:ring-teal-500 focus:border-teal-500"
                        >
                            <option value="" disabled>
                                Select an organization
                            </option>
                            {organizations.map((org) => (
                                <option key={org.id} value={org.id}>
                                    {org.name}
                                </option>
                            ))}
                        </select>
                        {errors.organizationId && (
                            <p className="text-red-500 text-sm mt-1">{errors.organizationId}</p>
                        )}
                    </div>
                )}

                <div>
                    <label className="block text-sm font-medium text-gray-700">
                        Mentor
                    </label>
                    <select
                        name="mentorId"
                        value={formData.mentorId}
                        onChange={handleChange}
                        disabled={!formData.organizationId}
                        className="block w-full px-4 py-2 mt-1 border rounded-md focus:ring-teal-500 focus:border-teal-500"
                    >
                        <option value="" disabled>
                            Select Mentor
                        </option>
                        {mentors.map((mt) => (
                            <option key={mt.id} value={mt.id}>
                                {mt.name}
                            </option>
                        ))}
                    </select>
                    {errors.mentorId && (
                        <p className="text-red-500 text-sm mt-1">{errors.mentorId}</p>
                    )}
                </div>

                <button
                    type="submit"
                    className="px-6 py-2 text-white bg-teal-600 rounded-md hover:bg-teal-700"
                >
                    Submit
                </button>
            </form>
        </div>
    );
};

export default NewDept;
